import { Box, Stack } from "@mui/material";

import Fsk8sPageContent from "./Fsk8sPageContent";

const Fsk8sPage = () => (
  <Box width="100%" mb={3}>
    <Stack spacing={2}>
      <Fsk8sPageContent />
    </Stack>
  </Box>
);
export default Fsk8sPage;
